import React, { Component, useState } from "react";
import SaveButton from "./SurveyForm/SaveButton";
import {
  Row,
  Col,
  NavItem,
  Nav,
  NavLink,
  TabPane,
  TabContent,
  Progress,
  Card,
  CardBody,
  CardFooter,
  FormGroup,
  Alert,
} from "reactstrap";
import SurveyForm from "./SurveyForm";
import InstructionModal from "./SurveyForm/InstructionModal";

class SurveyView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "0",
      validations: {},
      formValues: {},
      formErrors: {},
      alert: {
        message: "",
        color: "",
      },
      survey: {},
      submitModalOpen: false,
      editModalOpen: false,
    };

    this.submitSurvey = this.submitSurvey.bind(this);
    this.unsubmitSurvey = this.unsubmitSurvey.bind(this);
    this.submitModalToggle = this.submitModalToggle.bind(this);
    this.editModalToggle = this.editModalToggle.bind(this);
    this.dismissAlert = this.dismissAlert.bind(this);
    this.autoDismissAlert = this.autoDismissAlert.bind(this);
    this.alertTimeout;
  }

  dismissAlert() {
    this.setState({
      alert: {
        color: "",
        message: "",
      },
    });
  }

  submitModalToggle() {
    this.setState({
      submitModalOpen: !this.state.submitModalOpen,
    });
  }

  editModalToggle() {
    this.setState({
      editModalOpen: !this.state.editModalOpen,
    });
  }

  getFormInputs() {
    let formInputs = [];
    for (var key in this.state.formValues) {
      formInputs.push({
        id: key,
        value: this.state.formValues[key],
      });
    }
    return formInputs;
  }

  submitSurvey() {
    let formInputs = this.getFormInputs();
    return this.validateInputs(formInputs).then((validations) => {
      let doesPass = validations.every((validation) => validation.pass);
      let hasData = validations.some((validation) => validation.fieldValue);

      if (doesPass && hasData) {
        return this.props
          .onSubmit(this.state.survey.id, this.props.hotelId)
          .then((result) => {
            if (!result.error) {
              this.submitModalToggle();
              this.fetchSurveyData();
              this.setState(
                {
                  alert: {
                    message: "Submitted",
                    color: "success",
                  },
                },
                this.autoDismissAlert
              );
            } else {
              this.setState(
                {
                  alert: {
                    message: result.msg,
                    color: "danger",
                  },
                },
                this.autoDismissAlert
              );
            }
            return result;
          })
          .catch(() => {
            this.setState(
              {
                alert: {
                  message: "Failed submitting",
                  color: "danger",
                },
              },
              this.autoDismissAlert
            );
          });
      } else {
        let invalidField = validations.find((validation) => !validation.pass);
        this.focusField(invalidField);
        this.setState({
          alert: {
            message: "Invalid input data. Please correct it and submit again.",
            color: "danger",
            isOpen: this.visible,
            toggle: this.onDismiss,
          },
        });
        return {
          error: true,
        };
      }
    });
  }

  focusField(field) {
    let formId, rowId, colId;
    [formId, rowId, colId] = field.fieldId.split("_");
    this.toggle(formId - 1);
    let groups = this.state.forms[formId - 1].groups;
    let group = groups.find((group) =>
      group.rows.some((row) => row.id == rowId)
    );

    if (group.ref.current) {
      group.ref.current.scrollIntoView();
    }
  }

  unsubmitSurvey() {
    return this.props
      .onUnsubmit(this.state.survey.id, this.props.hotelId)
      .then((result) => {
        if (!result.error) {
          this.editModalToggle();
          this.fetchSurveyData();
        }
        return result;
      });
  }

  validateInputs(fields) {
    let formErrors = {};
    let validations = fields.map((field) => {
      let validation = this.validateInput(field.id, field.value);
      formErrors[field.id] = validation.messages;
      return validation;
    });

    return new Promise((resolve) => {
      this.setState(
        {
          formErrors: {
            ...this.state.formErrors,
            ...formErrors,
          },
        },
        () => {
          resolve(validations);
        }
      );
    });
  }

  validateInput(fieldId, fieldValue) {
    const fieldValidations = this.getFieldValidations();
    let result = this.validateMultipleRules(
      fieldValidations[fieldId],
      fieldValue
    );

    return {
      fieldId: fieldId,
      fieldValue: fieldValue,
      pass: result.pass,
      messages: result.messages,
    };
  }

  validateMultipleRules(rules, value) {
    let pass = true;
    let messages = [];
    if (!Array.isArray(rules)) {
      rules = [rules];
    }
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].dependent) {
        let dependentValueId = this.getDependentValueId(rules[i].dependent);
        let dependentValue = this.state.formValues[dependentValueId];
        rules[i]["value"] = dependentValue;
      }
      let result = this.validate(rules[i], value);

      if (!result.pass) {
        pass = false;
        // Do not push duplicated error
        if (messages.indexOf(result.message) == -1) {
          messages.push(result.message);
        }
      }
    }
    return {
      pass: pass,
      messages: messages,
    };
  }

  getDependentValueId(dependent) {
    return `${dependent.form}_${dependent.row}_${dependent.col}`;
  }

  validate(rule, value) {
    let type = rule;
    let pass = true;
    let message = "";
    if (typeof rule === "object") {
      type = rule.type;
    }
    switch (type) {
      case "email":
        pass = value !== "" ? /(.+)@(.+){2,}\.(.+){2,}/.test(value) : true;
        if (!pass) {
          message = "Invalid email address.";
        }
        break;
      case "max":
        pass = value.length <= rule.value;
        if (!pass) {
          message =
            "Value must not longer than " + rule.value + " character(s).";
        }
        break;
      case "required":
        pass = value !== "" && value !== null;
        if (!pass) {
          message = "This field is required.";
        }
        break;
      case "required_on":
        pass = this.validateRequiredOn(rule, value);
        if (!pass) {
          message = "This field is required.";
        }
        break;
      case "requires":
        pass = this.validateRequires(rule, value);
        if (!pass) {
          message = rule.dependent.text + " field is required";
        }
        break;
      case "number":
        pass = !isNaN(value);
        if (!pass) {
          message = "Must be a number.";
        }
        break;
      case "currency":
        var regex  = /^-?(?:0|[1-9]\d{0,2}(?:,?\d{3})*)(?:\.\d+)?$/;
        pass =  value !== "" ? regex.test(value) : true;
        if (!pass) {
          message = "Must be a currency.";
        }
        break;
      case "integer":
        pass = value !== "" ? Number.isInteger(parseInt(value)) : true;
        if (!pass) {
          message = "Must be a whole number.";
        }
        break;
      case "lte":
        pass = value !== "" ? Number(value) <= Number(rule.value) : true;
        if (!pass) {
          message =
            "Value must not be more than " +
            (rule.dependent ? rule.dependent.text : rule.value) +
            ".";
        }
        break;
      case "gte":
        pass = value !== "" ? Number(value) >= Number(rule.value) : true;
        if (!pass) {
          message =
            "Value must not be less than " +
            (rule.dependent ? rule.dependent.text : rule.value) +
            ".";
        }
        break;
      default:
        break;
    }
    return {
      pass: pass,
      message: message,
    };
  }

  validateRequiredOn(rule, value) {
    let pass = true;
    if (rule.rule === "dependent_not_empty") {
      if (value !== "" && value !== null) {
        pass = rule.value !== "" && rule.value !== null;
      }
    }
    return pass;
  }

  validateRequires(rule, value) {
    if (value !== "" && value !== null) {
      return rule.value !== "" && rule.value !== null;
    } else {
      return true;
    }
  }

  getFieldValidations() {
    return this.state.validations;
  }

  setFormValue(field, value) {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [field]: value,
        },
      },
      () => {
        if (
          this.state.formErrors[field] &&
          this.state.formErrors[field].length > 0
        )
          this.validateInputs([
            {
              id: field,
              value: this.state.formValues[field],
            },
          ]);
      }
    );
  }

  setFormError(field, message) {
    this.setState({
      formErrors: {
        ...this.state.formErrors,
        [field]: message,
      },
    });
  }

  getValidationsFromType(type) {
    let validations = [];
    switch (type) {
      case "currency":
        validations.push("currency");
        break;
      case "number":
        validations.push("number");
        break;
      case "percentage":
        validations.push("number");
        break;
      default:
        break;
    }

    return validations;
  }

  fetchSurveyData() {
    this.props.getData(this.props.id, this.props.hotelId).then((result) => {
      if (!result.error) {
        let survey = result.data;
        let forms = survey.forms;
        let values = {};

        let formValues = {};
        let validations = {};

        //// Get fields from forms
        forms.map((form) => {
          values = Object.assign(values, this.getValuesFromForm(form));
          if (
            survey.status === "on_going" &&
            survey.entry.status !== "submitted"
          ) {
            form["editAble"] = true && this.props.editAble;
          } else {
            form["editAble"] = false;
          }
        });

        Object.keys(values).forEach((key) => {
          formValues[key] = values[key].value;
          validations[key] = this.getValidationsFromType(
            values[key].type
          ).concat(values[key].validations);
        });

        this.setState({
          formValues: formValues,
          forms: forms,
          validations: validations,
          survey: survey,
        });
      }
    });
  }

  componentDidMount() {
    this.fetchSurveyData();
  }

  autoDismissAlert() {
    if (this.alertTimeout) {
      clearTimeout(this.alertTimeout);
    }
    this.alertTimeout = setTimeout(() => this.dismissAlert(), 1500);
  }

  saveValues(ids) {
    let formId;
    let cellValues = ids.map((id) => {
      let rowId, colId;
      [formId, rowId, colId] = id.split("_");
      return {
        row_id: rowId,
        col_id: colId,
        value: this.state.formValues[id],
      };
    });
    if (cellValues.length > 0) {
      return this.props
        .putData(this.props.id, this.props.hotelId, formId, cellValues)
        .then((result) => {
          if (!result.error) {
            this.setState(
              {
                alert: {
                  message: "Saved",
                  color: "success",
                },
              },
              this.autoDismissAlert
            );

            let formInputs = ids.map((id) => {
              return {
                id: id,
                value: this.state.formValues[id],
              };
            });
            this.validateInputs(formInputs);
          } else {
            this.setState(
              {
                alert: {
                  message: result.msg,
                  color: "danger",
                },
              },
              this.autoDismissAlert
            );
          }
        })
        .catch(() => {
          this.setState(
            {
              alert: {
                message: "Failed saving data",
                color: "danger",
              },
            },
            this.autoDismissAlert
          );
        });
    } else {
      return {
        error: true,
      };
    }
  }

  getValuesFromForm(form) {
    let values = {};
    form.groups.forEach((group) => {
      group.rows.forEach((row) => {
        row.cols.forEach((col) => {
          let id = [form.id, row.id, col.id].join("_");
          col["valueId"] = id;
          values[id] = {
            id: id,
            text: col.text,
            remark: col.remark,
            type: col.type,
            options: col.options,
            priority: col.priority,
            value: col.value,
            validations: col.validations,
          };
        });
      });
    });
    return values;
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  navLink(form, index) {
    return (
      <NavItem key={form.id}>
        <NavLink
          className={this.state.activeTab == index ? "active" : ""}
          onClick={() => {
            this.toggle(index);
          }}
        >
          {" "}
          {form.name}{" "}
        </NavLink>{" "}
      </NavItem>
    );
  }

  renderTab(form, index) {
    return (
      <TabPane
        tabId={index}
        key={form.id}
        className={this.state.activeTab == index ? "active" : ""}
      >
        <Row>
          <Col sm="12">
            <SurveyForm
              survey={this.state.survey}
              form={form}
              formValues={this.state.formValues}
              formErrors={this.state.formErrors}
              setFormValue={(field, value) => this.setFormValue(field, value)}
              saveValues={(values) => this.saveValues(values)}
              labelWidth={3}
            />{" "}
          </Col>{" "}
        </Row>{" "}
      </TabPane>
    );
  }

  renderStaticField(label, value) {
    return (
      <FormGroup row>
        <Col md="4">
          <strong> {label} </strong>{" "}
        </Col>{" "}
        <Col xs="12" md="8">
          <p className="form-control-static"> {value} </p>{" "}
        </Col>{" "}
      </FormGroup>
    );
  }

  renderFooter() {
    if (this.state.survey.status === "on_going" && this.props.editAble) {
      return (
        <CardFooter>
          {" "}
          {this.state.survey.entry.status === "unsubmitted" ? (
            <SaveButton text="Submit" onClick={this.submitSurvey} />
          ) : (
            <SaveButton text="Edit" onClick={this.unsubmitSurvey} />
          )}{" "}
          <InstructionModal
            isOpen={this.state.submitModalOpen}
            toggle={this.submitModalToggle}
            title={"Done! Your data has been received"}
            body={
              "Thank you for your participation. The survey results will be sent to you as soon as all participants have provided their data. Note: If you need to make additional edits, please click EDIT"
            }
            size={"lg"}
          />{" "}
          <InstructionModal
            isOpen={this.state.editModalOpen}
            toggle={this.editModalToggle}
            title={"Edit"}
            body={"Please click SUBMIT after you finished editing."}
            size={"lg"}
          />{" "}
        </CardFooter>
      );
    }
  }

  getEntryStatusText(status) {
    switch (status) {
      case "unsubmitted":
        return "Unsubmitted";
      case "submitted":
        return "Submitted";
    }
  }

  getStatusText(status) {
    switch (status) {
      case "inactive":
        return "Inactive";
      case "on_going":
        return "On Going";
      case "finished":
        return "Finished";
    }
  }

  convertDateTime(dateTimeString) {
    let date = new Date(dateTimeString);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  }

  render() {
    if (typeof this.state.forms !== "undefined") {
      return (
        <div className="animated fadeIn">
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Alert
                    className="float"
                    color={this.state.alert.color}
                    isOpen={this.state.alert.message != ""}
                    toggle={this.dismissAlert}
                  >
                    {" "}
                    {this.state.alert.message}{" "}
                  </Alert>{" "}
                  <Row>
                    <Col xs="12">
                      <Row>
                        <Col xs="6">
                          {" "}
                          {this.renderStaticField(
                            "Survey Name",
                            this.state.survey.name
                          )}{" "}
                        </Col>{" "}
                        <Col xs="6">
                          {" "}
                          {this.renderStaticField(
                            "Status",
                            `${this.getStatusText(
                              this.state.survey.status
                            )} (${this.getEntryStatusText(
                              this.state.survey.entry.status
                            )})`
                          )}{" "}
                        </Col>{" "}
                        <Col xs="6">
                          {" "}
                          {this.renderStaticField(
                            "Start Date",
                            this.convertDateTime(this.state.survey.start_date)
                          )}{" "}
                        </Col>{" "}
                        <Col xs="6">
                          {" "}
                          {this.renderStaticField(
                            "Date Due",
                            this.convertDateTime(this.state.survey.end_date)
                          )}{" "}
                        </Col>{" "}
                      </Row>{" "}
                    </Col>{" "}
                  </Row>{" "}
                  <Row>
                    <Col xs="12">
                      <Nav tabs>
                        {" "}
                        {this.state.forms.map((form, index) =>
                          this.navLink(form, index)
                        )}{" "}
                      </Nav>{" "}
                      <TabContent activeTab={this.state.activeTab}>
                        {" "}
                        {this.state.forms.map((form, index) =>
                          this.renderTab(form, index)
                        )}{" "}
                      </TabContent>{" "}
                    </Col>{" "}
                  </Row>{" "}
                </CardBody>{" "}
                {this.renderFooter()}{" "}
              </Card>{" "}
            </Col>{" "}
          </Row>{" "}
        </div>
      );
    } else {
      return (
        <div className="animated fadeIn">
          <Progress animated color="info" value={100} />{" "}
        </div>
      );
    }
  }
}

SurveyView.defaultProps = {
  editAble: true,
};

export default SurveyView;



// WEBPACK FOOTER //
// ./src/components/SurveyView/SurveyView.js